import { FadeLoader } from 'react-spinners';


const Loader = ({ loading, color = '#6842D9', style = {}, className = '' }:any) => {
  if (!loading) return null;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
        ...style,
      }}
      className={className}
    >
      <FadeLoader color={color} speedMultiplier={2} />
    </div>
  );
};

export default Loader;
